<template>
  <!--
    Contenedor con tabs para la gestión de atributos extra de una capa.
    Compone (sin modificar) el importador existente + las vistas de solo lectura.
      Tab "Resumen"  → totales + agrupación por (pedido, línea).
      Tab "Importar" → LayerImportExtraAttributes (intacto).
    (Tab "Elementos" — tabla por elemento — pendiente de definición.)
  -->
  <div class="w-full">
    <b-tabs v-model="activeTab" type="is-boxed" @input="onTabChange">

      <b-tab-item value="summary">
        <template #header>
          <b-icon pack="fas" icon="chart-simple" size="is-small" />
          <span class="ml-1">Resumen</span>
        </template>
        <LayerExtraAttributesSummary ref="summary" :layer="layer" />
      </b-tab-item>

      <b-tab-item value="elements">
        <template #header>
          <b-icon pack="fas" icon="table-list" size="is-small" />
          <span class="ml-1">Elementos</span>
        </template>
        <LayerExtraAttributesTable ref="table" :layer="layer" />
      </b-tab-item>

      <b-tab-item v-if="canImport" value="import">
        <template #header>
          <b-icon pack="fas" icon="file-import" size="is-small" />
          <span class="ml-1">Importar</span>
        </template>
        <LayerImportExtraAttributes :layer="layer" />
      </b-tab-item>

    </b-tabs>
  </div>
</template>

<script>
import LayerExtraAttributesSummary from './LayerExtraAttributesSummary.vue';
import LayerExtraAttributesTable from './LayerExtraAttributesTable.vue';
import LayerImportExtraAttributes from './LayerImportExtraAttributes.vue';
import { LAYER_CODES } from '../../constants/layer-codes.js';

export default {
  name: 'LayerExtraAttributesManager',

  components: {
    LayerExtraAttributesSummary,
    LayerExtraAttributesTable,
    LayerImportExtraAttributes,
  },

  props: {
    layer: { type: Object, required: true },
  },

  data() {
    return {
      activeTab: 'summary',
    };
  },

  computed: {
    // El import de atributos extra solo existe para pilings (PilingsExtraAttrsImport).
    // En structures/modules no hay strategy → ocultamos el tab "Importar".
    canImport() {
      return this.layer?.code === LAYER_CODES.PILINGS;
    },
  },

  methods: {
    // Al activar un tab de solo lectura lo refrescamos: fetch LAZY la primera
    // vez (la tabla no carga hasta abrirse) y datos frescos tras importar.
    onTabChange(value) {
      if (value === 'summary') {
        this.$refs.summary?.refresh?.();
      } else if (value === 'elements') {
        this.$refs.table?.refresh?.();
      }
    },
  },
};
</script>
